export const ticketTypes = {
    1: 'Top Tier Residential Pass - Single Occupancy',
    2: 'Top Tier Residential Pass - Double Occupancy',
    3: 'Top Tier Residential Pass - Triple Occupancy',
    4: 'Middle Tier Residential Pass - Single Occupancy',
    5: 'Middle Tier Residential Pass - Double Occupancy',
    6: 'Middle Tier Residential Pass - Triple Occupancy',
    7: 'Courtyard Room Residential Pass - Single Occupancy',
    8: 'Courtyard Room Residential Pass - Double Occupancy',
    9: 'Courtyard Room Residential Pass - Triple Occupancy',
    10: 'Non-Residential Week Pass',
    11: 'Indian Citizen Residential Pass - Double Occupancy',
    12: 'Indian Citizen Residential Pass - Triple Occupancy',
    13: 'Day 1 Pass - 09-Mar-2027',
    14: 'Day 2 Pass - 10-Mar-2027',
    15: 'Day 3 Pass - 11-Mar-2027',
    16: 'Day 4 Pass - 12-Mar-2027',
    17: 'Day 5 Pass - 13-Mar-2027',
    18: 'Day 6 Pass - 14-Mar-2027',
    19: 'Day 7 Pass - 15-Mar-2027',
    20: 'Pre-Festival Accommodation - 05-Mar-2027',
    21: 'Pre-Festival Accommodation - 06-Mar-2027',
    22: 'Pre-Festival Accommodation - 07-Mar-2027',
    23: 'Post-Festival Accommodation - 16-Mar-2027',
    24: 'Post-Festival Accommodation - 17-Mar-2027',
    25: 'Post-Festival Accommodation - 18-Mar-2027',  
    26: 'Sevak Pass',
    27: 'Orphanage Pass',
    28: 'Presenter Pass',
    29: 'Presenter-Assistant Pass',
    30: 'Reference Guest'
  };
